// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.ce-block .ce-block--focused[data-v-6468561e] {
        border: 1px dashed #cbcbcb !important
}
#editorjs[data-v-6468561e] {
        color: green;
}
.mce-content-body [data-mce-selected=inline-boundary][data-v-6468561e] {
        background-color: unset !important;
}
.card[data-v-6468561e]:hover {
        box-shadow: 0 1rem 1.75rem 0 rgba(45,55,75,.1);
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
